import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../api/axiosBaseQuery";

export const headerApi = createApi({
  reducerPath: "HeaderApi",
//   baseQuery: fetchBaseQuery({
//     baseUrl: "http://0.0.0.0:8000", // Base URL for the API
//   }),
  baseQuery: axiosBaseQuery,
  endpoints: (builder) => ({
    postLogout: builder.mutation({
      query: (data) => ({
        url: "/auth/logout",
        method: "POST",
        body: data,
      }),
    }),
    fetchManagerNotification: builder.query({
      query: () => ({
        url: `/report/notifications/manager/`,
        method: "GET",
      }),
    }),
    fetchUserNotification: builder.query({
      query: () => ({
        url: `/report/notifications/`,
        method: "GET",
      }),
    }),
    updateNotification: builder.mutation({
      query: (notificationId) => ({
        url: `/report/notifications/${notificationId}/mark-read/`,
        method: "PUT",
      }),
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useFetchManagerNotificationQuery,
  useFetchUserNotificationQuery,
  
  usePostLogoutMutation,
  useUpdateNotificationMutation,
} = headerApi;

export default headerApi;
